// src/client/utils/csv-export.ts

/**
 * Generic utility function to export data as a CSV file
 * @param filename - Name of the file to be downloaded
 * @param headers - Array of column headers
 * @param data - Array of objects containing the data to export
 * @param mapFunction - Function to map each data object to an array of values
 */
export const exportToCsv = (
  filename: string,
  headers: string[],
  data: any[],
  mapFunction: (item: any) => (string | number | undefined | null)[]
) => {
  try {
    if (!data || data.length === 0) {
      console.error('No data available to export.');
      return;
    }

    // Create CSV header row
    const csvRows = [headers.join(',')];

    // Create a generator function to handle large datasets
    const generateCsvRows = function* () {
      for (const item of data) {
        const values = mapFunction(item);
        yield values.join(',');
      }
    };

    // Create a CSV string from the generator
    for (const row of generateCsvRows()) {
      csvRows.push(row);
    }

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error exporting CSV:', error);
  }
};
